export const isDate = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/
export const isIban = /^(NL|nl)[0-9]{2}[A-z0-9]{4}[0-9]{10}$/
export const isUuid =
  /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i
export const isBsn = /^[0-9]{8,9}$/
